// Copyright (c) 2016 Deere & Company

import AttachmentClaimContainer from '../../claim/attachment/state-connector';

export default {
    component: AttachmentClaimContainer,
    name: 'ATTACHMENTS',
    path: 'attachment/edit/:claimNumber'
};



// WEBPACK FOOTER //
// ./src/routes/claims/edit-attachment-claim-route.js